@if (!isLoading()) {
  <main>
    <router-outlet></router-outlet>
  </main>
} @else {
  <div class="spinner">
    <app-spinner [diameter]="60" />
  </div>
}
